import type { Transform } from "web_myplann/Chat/Types/pinchZoom";

export const toTransformCss = ({ scale, x, y }: Transform) =>
	`translate(${x}px, ${y}px) scale(${scale})`;
